import { useTranslation } from 'react-i18next'

import { ErrorAlert } from '@repo/ui'
import SimpleApplyCancelDialog from '@/components/common/dialog/SimpleApplyCancelDialog'
import useBfnQuittierenMutation from '@/features/befehlsnachrichten/mutations/useBfnQuittierenMutation'
import { Abruftoken } from '@/models/Abruftoken'

export interface BfnQuittierenDialogProps {
  abruftoken: Abruftoken
  state: boolean
  onClose: () => void
  'data-testid': string
}

export default function BfnQuittierenDialog({
  abruftoken,
  state,
  onClose,
  'data-testid': testId
}: Readonly<BfnQuittierenDialogProps>) {
  const { t } = useTranslation('bfnDetails')
  const mutation = useBfnQuittierenMutation(abruftoken)

  const onApply = () => {
    mutation.mutate(undefined, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  return (
    <SimpleApplyCancelDialog
      title={t('dialog.quittieren.title')}
      state={state}
      onApply={onApply}
      onCancel={onClose}
      applyButtonDisabled={mutation.isPending}
      applyButtonText={t('dialog.quittieren.apply')}
      cancelButtonText={t('dialog.quittieren.cancel')}
      data-testid={testId}
    >
      <p data-testid={`${testId}-text`}>{t('dialog.quittieren.text')}</p>
      {mutation.isError && (
        <ErrorAlert error={mutation.error} data-testid={`${testId}-error`}>
          {t('dialog.quittieren.error')}
        </ErrorAlert>
      )}
    </SimpleApplyCancelDialog>
  )
}
